export const FUNERAL_DIRECTOR_TERMS_VERSION = '1.0';
export const FUNERAL_DIRECTOR_TERMS_EFFECTIVE_DATE = '1/1/2026';

export const FUNERAL_DIRECTOR_TERMS_HTML = (
  <>
    <h1>AGREEMENT BETWEEN IMOBITUARY, LLC AND FUNERAL DIRECTOR, Parent Company / Holding Company</h1>

    <p>Agreement Date:</p>

    <p>This Agreement ("Agreement") is entered into by and between IMObituary, LLC, a Colorado Limited Liability Company ("IMObituary"), and the Funeral Director(s), Parent Company / Holding Company will be referred to as ("Funeral Director").</p>

    <h2>1. Services Provided</h2>
    <p>IMObituary will enable families served by the Funeral Director to:</p>
    <ul>
      <li>Send mobile obituaries via text message to loved ones and friends of the deceased.</li>
      <li>Create and send custom memorial cards to those same recipients.</li>
    </ul>

    <h2>2. Account Setup</h2>
    <ul>
      <li>Funeral Directors are required to create and maintain a valid IMObituary account to access and manage services.</li>
      <li>Funeral Directors must provide accurate and current business and contact information.</li>
    </ul>

    <h2>3. Stripe Connect Account Setup</h2>
    <ul>
      <li>Funeral Directors must establish and verify a Stripe Connect account to receive commissions.</li>
      <li>IMObituary is not responsible for delays, errors, or nonpayment caused by incomplete or inaccurate Stripe account setup.</li>
    </ul>

    <h2>4. Collection of Recipient Information</h2>
    <ul>
      <li>Funeral Directors are responsible for collecting and submitting accurate mailing addresses and recipient information.</li>
      <li>IMObituary is not responsible for errors resulting from incorrect or incomplete data submitted by Funeral Directors.</li>
    </ul>

    <h2>5. Distribution of Obituaries and Cards</h2>
    <ul>
      <li>Funeral Directors are responsible for ensuring obituary details are delivered to recipients via text.</li>
      <li>IMObituary will facilitate the creation, production, and mailing of custom memorial cards.</li>
    </ul>

    <h2>6. Compensation</h2>
    <ul>
      <li>Funeral Directors will receive $5 per memorial card sold through their network.</li>
      <li>Payments are processed monthly via the verified Stripe Connect account and are subject to sales verification.</li>
    </ul>

    <h2>7. Maintenance Fee</h2>
    <ul>
      <li>Funeral Director(s), Parent Company / Holding Company agrees to pay a $50 monthly fee per location for the mobile text obituary service.</li>
      <li>The monthly fee is adjustable at the discretion of ownership or the management team and may include discounts or other modifications.</li>
      <li>The monthly maintenance fee of $50 per location subject to change annually at the discretion of IMObituary's ownership or management. Any changes will be communicated in writing at least 30 days in advance and will take into consideration the nature of the services provided and market conditions.</li>
    </ul>

    <h2>8. Ownership & Intellectual Property</h2>
    <ul>
      <li>All card designs, templates, software, digital content, and intellectual property remain the sole property of IMObituary.</li>
      <li>Funeral Directors may not reproduce, sell, sublicense, or distribute IMObituary materials outside the scope of this Agreement.</li>
    </ul>

    <h2>9. Confidentiality</h2>
    <ul>
      <li>Both parties agree to keep confidential any proprietary, technical, or sensitive business information disclosed under this Agreement.</li>
      <li>Confidentiality obligations survive termination of this Agreement for 5 years.</li>
    </ul>

    <h2>10. Data Privacy and Security</h2>
    <ul>
      <li>IMObituary will handle personal information in compliance with applicable data protection and privacy laws.</li>
      <li>Funeral Directors may represent to families that information will be used solely for services described in this Agreement.</li>
    </ul>

    <h2>11. Compliance</h2>
    <ul>
      <li>Funeral Directors must comply with all applicable local, state, and federal laws, including privacy, marketing, and data regulations.</li>
      <li>Funeral Directors shall not engage in unlawful, deceptive, or unethical practices using IMObituary services.</li>
    </ul>

    <h2>12. Performance Metrics</h2>
    <p>The parties may establish and review key performance indicators (KPIs) periodically to assess service effectiveness and partnership success.</p>

    <h2>13. Term and Termination</h2>
    <ul>
      <li>This Agreement remains in effect until terminated.</li>
      <li>Either party may terminate this Agreement for convenience with 30 days' written notice.</li>
      <li>IMObituary may terminate immediately for material breach, including nonpayment, misuse of intellectual property, or legal noncompliance.</li>
    </ul>

    <h2>14. Limitation of Liability</h2>
    <ul>
      <li>IMObituary's total liability under this Agreement shall not exceed the amount paid by the Funeral Director during the preceding three (3) months.</li>
      <li>IMObituary shall not be liable for indirect, incidental, special, or consequential damages.</li>
    </ul>

    <h2>15. Indemnification</h2>
    <p>Funeral Directors agree to indemnify and hold harmless IMObituary from claims, damages, losses, or expenses arising from their acts, omissions, or breaches of this Agreement.</p>

    <h2>16. Dispute Resolution</h2>
    <ul>
      <li>Any dispute arising under this Agreement shall first be submitted to mediation.</li>
      <li>If unresolved, disputes shall proceed to binding arbitration under Colorado law.</li>
    </ul>

    <h2>17. Non-Compete / Non-Solicitation</h2>
    <p>During the term of this Agreement and for 2 years following termination, Funeral Directors shall not:</p>
    <ul>
      <li>Create or offer a competing mobile obituary or memorial card service within regions where IMObituary has a significant market presence.</li>
      <li>Solicit IMObituary customers for substantially similar services.</li>
    </ul>

    <h2>18. Force Majeure</h2>
    <p>Neither party shall be liable for delays or failures caused by events beyond reasonable control, including natural disasters, pandemics, or network outages.</p>

    <h2>19. Contract Changes</h2>
    <ul>
      <li>IMObituary may amend this Agreement with 30 days' written notice.</li>
      <li>Continued use of IMObituary services constitutes acceptance of amended terms.</li>
    </ul>

    <h2>20. Notices</h2>
    <p>Notices must be delivered via email or certified mail to the addresses provided by each party.</p>

    <h2>21. Governing Law</h2>
    <ul>
      <li>This Agreement is governed by the laws of the State of Colorado.</li>
      <li>Venue for legal proceedings shall be in Larimer County, Colorado, unless otherwise agreed in writing.</li>
    </ul>
  </>
);
